namespace Matrix.Rebalancer {
    export interface SortSettingsRow {
        Context?: string;
        Code?: string;
        SortId?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace SortSettingsRow {
        export const idProperty = 'RowId';
        export const nameProperty = 'Context';
        export const localTextPrefix = 'Rebalancer.SortSettings';
        export const deletePermission = 'DataAdmin:Rebalancer';
        export const insertPermission = 'DataAdmin:Rebalancer';
        export const readPermission = 'Read:Rebalancer';
        export const updatePermission = 'DataAdmin:Rebalancer';

        export declare const enum Fields {
            Context = "Context",
            Code = "Code",
            SortId = "SortId",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
